/** GraphQL Mutation that creates new customer address. */
export default `
  mutation createCustomerAddress($input: CustomerAddressInput!) {
    createCustomerAddress(input: $input) {
      id
      region {
        region
        region_id
        region_code
      }
      country_code
      street
      telephone
      postcode
      city
      default_shipping
      default_billing
      vat_id
      company
      custom_attributesV2(attributeCodes: [
        "company_email", "invoice_email"
      ]){
        code
        ... on AttributeValue {
          value
        }
      }
    }
  }
`;
